import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useState } from "react";

export const EditableDescription = ({
  description,
  setDescription,
  endAdornment,
}: {
  description?: string;
  setDescription?: (description: string) => void;
  endAdornment?: React.ReactNode;
}) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();
  const [inputOpen, setInputOpen] = useState(false);
  const [newDescription, setNewDescription] = useState(description ?? "");
  const handleClose = () => {
    setInputOpen(false);
  };

  return (
    <Stack direction="row" alignItems="center">
      {setDescription === undefined ? null : (
        <>
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              setInputOpen(true);
            }}
            sx={{
              paddingBottom: 1,
              maxWidth: "30px",
              maxHeight: "30px",
              minWidth: "30px",
              minHeight: "30px",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <EditRoundedIcon />
          </IconButton>
          <Dialog open={inputOpen} onClose={handleClose}>
            <DialogContent sx={{ minWidth: 350 }}>
              <TextField
                autoFocus
                value={newDescription}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setNewDescription(event.target.value);
                }}
                label={t("description")}
                multiline
                fullWidth
                variant="standard"
              />
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="outlined"
                onClick={handleClose}
                startIcon={<CancelRoundedIcon sx={{ fontSize: 14 }} />}
                size="small"
              >
                {t("cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setDescription(newDescription);
                }}
                startIcon={<EditRoundedIcon />}
                size="small"
              >
                {t("confirm")}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      <Typography
        sx={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          paddingX: 0.5,
          paddingBottom: 1,
          maxHeight: theme.spacing(6),
          overflowY: "auto",
        }}
      >
        {description ?? ""}
      </Typography>
      {endAdornment !== undefined && (
        <Stack sx={{ paddingBottom: 1 }}>{endAdornment}</Stack>
      )}
    </Stack>
  );
};
